// extracted by mini-css-extract-plugin
export default {"container":"c070o","header":"qksDn","notPGLayout":"beNO4","notPgLayout":"beNO4","withPadding":"tt7mK","menu":"HuHZZ"};